var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import { SchedulerSlot } from './SchedulerSlot';
import { useSlotExpand } from '../hooks';
/* eslint-disable max-len */
/**
 * Represents the default `viewSlot` component rendered by the [KendoReact Scheduler component]({% slug overview_scheduler %}).
 *
 * This is a composite component of the [`SchedulerSlot`]({% slug api_scheduler_schedulerslot %}), extending it to provide additional functionality depending on the view.
 */
// tslint:enable:max-line-length
export var SchedulerViewSlot = React.forwardRef(function (props, ref) {
    var propSlot = props.slot, _ref = props._ref, slotProps = __rest(props, ["slot", "_ref"]);
    var Slot = propSlot || defaultProps.slot;
    var viewSlot = React.useRef(null);
    var slot = React.useRef(null);
    React.useImperativeHandle(viewSlot, function () { return ({ props: props }); });
    React.useImperativeHandle(_ref, function () { return slot.current; });
    React.useImperativeHandle(ref, function () { return viewSlot.current; });
    useSlotExpand(slot, props.expandable);
    return (React.createElement(Slot, __assign({}, slotProps, { _ref: slot })));
});
var defaultProps = {
    slot: SchedulerSlot
};
SchedulerViewSlot.defaultProps = defaultProps;
SchedulerViewSlot.displayName = 'KendoReactSchedulerViewSlot';
//# sourceMappingURL=SchedulerViewSlot.js.map